import { createRoot } from 'react-dom/client'
import { Provider as ReduxProvider } from 'react-redux'
import { store } from './store'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import './tailwind.build.css'
import {App} from './App'
import * as serviceWorker from './serviceWorker'
import { ThemeProvider } from "@mui/material/styles"
import { theme } from "./components/mui/theme"
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js';


const container = document.getElementById('root')
if (!container) throw new Error('Not found: element #root in which to render react-app')

const shouldInitializePosthog = window.location.host === 'app.wistor.nl'

if (shouldInitializePosthog) {
  posthog.init("phc_d3AXtnp7vSKaCQKS7q3sdH7hDhODSBkxHSAzzkFanJp", {
    api_host: "https://posthog.bim-connected.com",
    defaults: '2025-11-30',
  })
}

const root = createRoot(container)
root.render(
  <ReduxProvider store={store}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <PostHogProvider client={posthog}>
          <App />
        </PostHogProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </ReduxProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
//serviceWorker.register();

declare global {
  interface Window {
    bbFolderName: string
  }
}
